<template>
  <span
    :key="uuid"
    v-blink="formmattedLatestPrice"
    class="mod-latest-price"
    :class="cls"
  >
    <span class="price">
      <span>{{ formmattedLatestPrice }}</span>
      <icon v-if="isRise && showIcon" name="arrow-up-thin" />
      <icon v-if="isFall && showIcon" name="arrow-down-thin" />
    </span>
    <span v-if="showChange" class="change">
      {{ change | floatNum(null, digits, !!latestPrice) | sign }}
    </span>
    <span v-if="showChangeRate" class="change-rate">
      {{ changeRate | percent(2, true, !!latestPrice) }}
    </span>
  </span>
</template>
<script>
import Icon from 'com/Icon'
export default {
  components: { Icon },
  props: {
    stock: Object,
    isHourTrading: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    showChange: {
      type: Boolean,
      default: true
    },
    showChangeRate: {
      type: Boolean,
      default: true
    },
    showZero: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    uuid() {
      return this.stock.webLocal
        ? this.stock.webLocal.symbol
        : this.stock.symbol
    },
    latestPrice() {
      if (this.isHourTrading) {
        return this.stock.hourTradingLatestPrice
      }
      return this.stock.latestPrice
    },
    formmattedLatestPrice() {
      return this.$options.filters.floatNum(
        this.latestPrice,
        this.stock,
        null,
        !this.showZero
      )
    },
    preClose() {
      return this.stock.preClose
    },
    digits() {
      return this.stock.digits
    },
    isFall() {
      return this.change < 0
    },
    isRise() {
      return this.change > 0
    },
    change() {
      if (this.isHourTrading) {
        return this.stock.hourTradingChange
      }
      return this.stock.change
    },
    changeRate() {
      if (this.isHourTrading) {
        return this.stock.hourTradingChangeRate
      }
      return this.stock.changeRate
    },
    cls() {
      const noPrice =
        !this.latestPrice || (this.latestPrice === 0 && !this.showZero)
      return [
        this.$options.filters.redGreen(this.change),
        this.isHourTrading && 'is-hour-trading',
        noPrice && 'no-price'
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.mod-latest-price {
  display: flex;
  align-items: baseline;
  line-height: 1;

  .price {
    display: flex;
    align-items: baseline;
    margin-right: 5px;
    font-size: 18px;
  }
  .icon {
    width: 12px;
    height: 12px;
  }
  .change,
  .change-rate {
    font-size: 14px;
  }
  .change {
    margin-right: 3px;
  }
  // 无数据情况下居中对齐
  &.no-price {
    align-items: center;
    .price {
      align-items: center;
    }
  }
}
</style>
